class FilterDropdown extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      if (event.target.closest('.filter-dropdown__summary')) this.toggle();
    });
  }

  toggle() {
    const isOpen = this.classList.contains('open');
    FilterDropdown.closeAll();
    if (!isOpen) this.open();
  }

  open() {
    this.classList.add('open');
    const summary = this.querySelector('.filter-dropdown__summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.classList.remove('open');
    const summary = this.querySelector('.filter-dropdown__summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  static closeAll() {
    document.querySelectorAll('filter-dropdown.open').forEach((el) => el.close());
  }
}

customElements.define('filter-dropdown', FilterDropdown);

document.addEventListener('click', (event) => {
  if (event.target.closest('filter-dropdown')) return;
  FilterDropdown.closeAll();
});
